import frequencyApi from '../../request/frequencyApi';
import addressApi from '../../request/addressApi';
import contactApi from '../../request/contactApi';
import baseTool from '../../utils/baseFunction';

const state = {
  DefaultAddress: null, // 默认地址
  SetDate: baseTool.dateFormat(new Date(), 'yyyy-MM-dd'), // 选择日期
  SetTime: '05:00', // 时间
  OrderType: 1, // 订单类型
  PickupPriceModel: null, // 接送价格模板
  SelectedFrequency: [], // 选择线路
  Province: '广东省', // 省份
  City: '中山市', // 城市
  GetOn: '',
  GetOff: '',
  GetType:1,//大巴类型，1去程 2返程 3来回
  LuggageCount: 0, // 行李数量
  ContactList: [], // 乘客列表
}

const getters = {

}

const actions = {
  getDefaultAddress({
    commit,
    state
  }, OpenId) {
    addressApi.getAddressList(OpenId, '').then(sucRes => {
      let result = sucRes;
      if (result.success && result.data.length > 0) {
        for (let i = 0; i < result.data.length; i++) {
          if (result.data[i].IsDefault) {
            commit('setDefaultAddress', result.data[i]);
            return true;
          }
        }
      } else {
        return false;
      }
    });
  },
  getPickupPriceModel({
    commit,
    state
  }, ModelID) {
    if (state.DefaultAddress) {
      frequencyApi.getPickupAreaPriceList(state.City, ModelID).then(sucRes => {
        let result = sucRes;
        if (result.success && result.data.length > 0) {
          for (let i = 0; i < result.data.length; i++) {
            if (result.data[i].District == state.DefaultAddress.District && result.data[i].Status) {
              commit('setPickupPriceModel', result.data[i]);
              return true;
            }
          }
          return false;
        } else return false;
      });
    } else return false;
  }
}

const mutations = {
  setTicketMode(state) {
    state.DefaultAddress = null;
    state.OrderType = 1;
    state.LuggageCount = 0;
    state.PickupPriceModel = null;
  },
  setPickupMode(state, data) {
    state.OrderType = 2;
    state.DefaultAddress = data.DefaultAddress;
    state.PickupPriceModel = data.PickupPriceModel;
  },
  setDefaultAddress(state, defaultAddress) {
    state.DefaultAddress = defaultAddress;
  },
  setPickupPriceModel(state, pickupPriceModel) {
    state.PickupPriceModel = pickupPriceModel;
  },
  setBaseTicketCondition(state, dataObj) {
    for (let prop in dataObj) {
      if (dataObj[prop] !== undefined) {
        state[prop] = dataObj[prop];
      }
    }
  },
  clearData(state) {
    state.DefaultAddress = null;
    state.OrderType = 1; // 订单类型
    state.PickupPriceModel = null; // 接送价格模板
    state.SelectedFrequency = []; // 选择线路
    state.LuggageCount = 0; // 行李数量
    state.ContactList = []; // 乘客列表
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ticket.js